/* eslint-disable camelcase */
// TODO: `text` and `message` should point to `this.$store.state.content.<KEY>`
const actionLabelMap = {
  action_chat: {
    action: 'jeLiveChat.start',
    message: '',
    primary: false,
    text: 'action_chat_link_text',
    type: 'live_chat'
  },
  action_chat_primary: {
    action: 'jeLiveChat.start',
    message: '',
    primary: true,
    text: 'action_chat_link_text',
    type: 'live_chat'
  },
  action_order_again: {
    action: '/',
    message: '',
    primary: false,
    text: 'action_order_again_link_text',
    type: 'link'
  },
  action_order_again_primary: {
    action: '/',
    primary: true,
    text: 'action_order_again_link_text',
    type: 'link'
  },
  action_refund: {
    action: 'jeLiveChat.start',
    message: 'action_refund_link_text',
    primary: false,
    text: 'action_refund_link_text',
    type: 'live_chat'
  },
  action_refund_primary: {
    action: 'jeLiveChat.start',
    message: 'action_refund_link_text',
    primary: true,
    text: 'action_refund_link_text',
    type: 'live_chat'
  },
  action_redeliver_again: {
    action: 'jeLiveChat.start',
    message: 'action_redeliver_link_text',
    primary: false,
    text: 'action_order_again_link_text',
    type: 'live_chat'
  },
  action_redeliver_primary: {
    action: 'jeLiveChat.start',
    message: 'action_redeliver_link_text',
    primary: true,
    text: 'action_order_again_link_text',
    type: 'live_chat'
  }
}

export default actionLabelMap
